// components/EventRedirect.js
import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

function EventRedirect() {
  const { eventId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to agenda with the event ID as query parameter
    navigate(`/agenda?event=${eventId}`, { replace: true });
  }, [eventId, navigate]);

  return (
    <div className="loading-state">
      <div className="loading-spinner"></div>
      <p>Redirigiendo al evento...</p>
    </div>
  );
}

export default EventRedirect;
